import { render } from "./SearchDisableLockUser.vue?vue&type=template&id=5b904b66&scoped=true"
const script = {}

import "./SearchDisableLockUser.vue?vue&type=style&index=0&id=5b904b66&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b904b66"]])

export default __exports__